<template>
  <div v-html="message.text"></div>
  <div class="chat-widget__message-footer">
    <div class="chat-widget__message-control">
      <Button variant="text"
              @click="regenerate(message)"
              label=""
              v-if="message.can_regenerate"
              :disabled="appStore.blockSending"
              v-tooltip.bottom="regenerateTooltip"
              icon="pi pi-sync"
              iconPos="right">
      </Button>
    </div>
  </div>
</template>

<script setup>
import Button from "primevue/button";
import {computed} from "vue";
import {useAppStateStore} from "@/modules/chat/stores/appStore";

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
});

const appStore = useAppStateStore();
const regenerateTooltip = computed(() => {
  if (props.message.batch_job_id && !appStore.blockSending) {
    return 'Переотправить запрос ассистентам';
  }

  return appStore.blockSending ? 'Дождитесь завершения предыдущего запроса' : 'Перегенерировать'
});

const regenerate = async (message) => {
  if (message.job_id) {
    await appStore.handleRetryJobId(message.id, message.job_id);
  } else if (message.batch_job_id) {
    await appStore.handleRetryBatchJobId(message.batch_job_id);
  } else {
    await appStore.handleRegenerateErrorSending(message.id, message.regeneration_id);
  }
};
</script>